/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.8.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());
export { Location };
//# sourceMappingURL=Location.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-properties-js/dist-esm/Context/Location.js
// module id = 373
// module chunks = 0